import Section from "components/base/Section";
import { Tabs } from "components/base/Tabs";
import PolitiqueConfidentialite from "./PolitiqueConfidentialite";
import CGU from "./CGU";
import CGV from "./CGV";
import MentionsLegales from "./MentionsLegales";
import { useSearchParams } from "react-router-dom";

export default function LegalPagesContent() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  
  return (
    <Section fullwidth>
      <Tabs defaultTab={tab ? parseInt(tab) : 0} tabs={
        [
          {
            label: 'Conditions Générales d\'Utilisation',
            content: <CGU />            
          },
          {
            label: 'Conditions Générales de Vente',
            content: <CGV />
          },
          {
            label: 'Politique de Confidentialité',
            content: <PolitiqueConfidentialite />
          },
          {
            label: 'Mentions Légales',
            content: <MentionsLegales />
          },
        ]
      } />
    </Section>
  );
}